import { render } from "./DistributionOfTransfersPerBankChartContainer.vue?vue&type=template&id=fbd4dcc4"
import script from "./DistributionOfTransfersPerBankChartContainer.vue?vue&type=script&lang=js"
export * from "./DistributionOfTransfersPerBankChartContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__